import {
  Column,
  ColumnDirective,
  ColumnsDirective,
  EditSettingsModel,
  GridComponent,
  Group,
  Inject,
} from '@syncfusion/ej2-react-grids';
import { GetBackendUrlForGlobalFunctions } from '../../App';
import {
  Edit,
  Toolbar,
  FilterSettingsModel,
  Filter,
  PageSettingsModel,
  Page,
  ColumnMenu,
  Resize,
} from '@syncfusion/ej2-react-grids';
import * as React from 'react';
import { connect } from 'react-redux';
import {
  DialogComponent,
  AnimationSettingsModel,
  ButtonPropsModel,
} from '@syncfusion/ej2-react-popups';
import { TextBoxComponent } from '@syncfusion/ej2-react-inputs';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import 'react-jquery-plugin';
import { all_information, loadingShow } from '../../App';
import Message from '../../utils/Message/Message';
import {
  DropDownListComponent,
  MultiSelectComponent,
} from '@syncfusion/ej2-react-dropdowns';
import { UploaderComponent } from '@syncfusion/ej2-react-inputs';
import { getValue } from '@syncfusion/ej2-base';
import ReactDOM from 'react-dom';
import defaultImage from '../../assets/images/DefaultImage.png';
import './style.css';
import { ThemeContext } from '../../context/theme.context';
import { getTeams } from '../../services/tradeperson/team';
import {
  addAssignment,
  deleteAssignment,
  editAssignment,
  getAssignments,
  setterTeamAndTradeToAssignment,
} from '../../services/assignments/assignmentService';
import { getTrades } from '../../services/tradeperson/trades';
import {
  setAssignments,
  setRefreshAssignmentComponent,
  setRefreshTeamComponent,
  setRefreshTradeComponent,
  setStoreAssign,
  setTrades,
} from '../../redux/search.slice';
import { RootState } from '../../store';
interface IProps {
  setTrades: (data: number[]) => void;
  setRefreshTradeComponent: (data: boolean) => void;
  setRefreshTeamComponent: (data: boolean) => void;
  defaultTeams: number[];
  refreshAssignmentComponent: boolean;
  setRefreshAssignmentComponent: (data: boolean) => void;
  setAssignments: (data: number[]) => void;
  setStoreAssign: (data: string[]) => void;
  defaultAssignments: number[];
  defaultTrades: number[];
  storeAssign: string[];
}
interface TeamInfo {
  team_id: number;
  trade_id: number;
}
interface IState {
  AssignmentData: any;
  hideDialog: boolean;
  firstName: any;
  lastName: any;
  teamId: any;
  tradeId: any;
  hideDialogDelete: boolean;
  hideDialogEdit: boolean;
  pickedAssignmentId: any;
  dropdownTeamSelection: any;
  dropdownTradeSelection: any;
  dropdownTeamSelectionForEdit: any;
  dropdownTradeSelectionForEdit: any;
  teamData: any;
  tradeData: any;
}
class Teams extends React.Component<IProps, IState> {
  static contextType = ThemeContext;
  context!: React.ContextType<typeof ThemeContext>;
  public editOptions: EditSettingsModel = {
    allowAdding: true,
    allowDeleting: true,
    allowEditing: true,
    allowEditOnDblClick: true,
    showConfirmDialog: true,
    showDeleteConfirmDialog: true,
  };
  public uploaderObj: UploaderComponent;
  public customStyles = {
    option: (provided: any, state: any) => ({
      ...provided,
      borderBottom: '1px dotted pink',
      color: this.context.isDarkMode ? 'white' : '#15202B',
      padding: 5,
      backgroundColor: this.context.isDarkMode ? '#15202B' : 'white',
    }),
    control: (style: any) => ({
      // none of react-select's styles are passed to <Control />
      ...style,
      width: 250,
      backgroundColor: this.context.isDarkMode ? '#15202B' : 'white',
    }),
    singleValue: (provided: any, state: any) => {
      const opacity = state.isDisabled ? 0.5 : 1;
      const transition = 'opacity 300ms';

      return { ...provided, opacity, transition };
    },
  };
  public shipFormat: object = { type: 'date', format: 'dd/MM/yyyy' };
  public toolbarOptions = [
    {
      text: 'Add',
      tooltipText: 'Add',
      prefixIcon: 'e-add',
      id: 'add',
    },
    {
      text: 'Edit',
      tooltipText: 'Edit',
      prefixIcon: 'e-edit',
      id: 'edit',
    },
    {
      text: 'Delete',
      tooltipText: 'Delete',
      prefixIcon: 'e-delete',
      id: 'delete',
    },
    {
      text: 'Refresh',
      tooltipText: 'Refresh',
      prefixIcon: 'e-refresh',
      id: 'refresh',
    },
  ];
  public FilterOptions: FilterSettingsModel = { type: 'Menu' };
  public pageOptions: PageSettingsModel = {
    currentPage: 1,
    pageSize: 12,
    pageCount: 8,
    pageSizes: true,
  };

  private buttons: ButtonPropsModel[];
  private buttonsDelete: ButtonPropsModel[];
  private buttonsEdit: ButtonPropsModel[];
  private grid: any;
  private animationSettings: AnimationSettingsModel;
  private time: Date = new Date('8/3/2017 10:00');
  private asyncSettings = {
    saveUrl: 'http://localhost:62869/api/SQLProvider/SQLUpload',
    removeUrl: 'https://ej2.syncfusion.com/services/api/uploadbox/Remove',
  };
  constructor(props: IProps) {
    super(props);
    this.animationSettings = { effect: 'Zoom', duration: 400, delay: 0 };
    this.buttonsEdit = [
      {
        click: () => {
          this.editAssignment();
        },
        buttonModel: {
          content: 'Done',
          isPrimary: true,
        },
      },
      {
        click: () => {
          this.setState({ hideDialogEdit: false });
        },
        buttonModel: {
          content: 'No',
        },
      },
    ];
    this.buttonsDelete = [
      {
        click: () => {
          this.deleteAssignment();
        },
        buttonModel: {
          content: 'Yes',
          isPrimary: true,
        },
      },
      {
        click: () => {
          this.setState({ hideDialogDelete: false });
        },
        buttonModel: {
          content: 'No',
        },
      },
    ];
    this.buttons = [
      {
        click: () => {
          this.addAssignment();
        },
        buttonModel: {
          content: 'Save',
          isPrimary: true,
        },
      },
      {
        click: () => {
          this.setState({ hideDialog: false });
        },
        buttonModel: {
          content: 'Cancel',
        },
      },
    ];
    this.state = {
      teamData: [],
      tradeData: [],
      dropdownTeamSelection: '',
      dropdownTradeSelection: '',
      dropdownTeamSelectionForEdit: '',
      dropdownTradeSelectionForEdit: '',
      pickedAssignmentId: '',
      hideDialogDelete: false,
      hideDialogEdit: false,
      AssignmentData: [],
      hideDialog: false,
      teamId: '',
      tradeId: '',
      firstName: '',
      lastName: '',
    };
    this.uploaderObj = new UploaderComponent(props);
  }
  private dialogClose(): void {
    this.setState({
      hideDialog: false,
    });
  }
  private dialogOpen(): void {
    this.setState({ hideDialog: true });
  }

  private dialogOpenDelete(): void {
    this.setState({ hideDialogDelete: true });
  }
  private dialogCloseDelete(): void {
    this.setState({
      hideDialogDelete: false,
    });
  }

  private dialogOpenEdit(): void {
    this.setState({ hideDialogEdit: true });
  }
  private dialogCloseEdit(): void {
    this.setState({
      hideDialogEdit: false,
    });
  }

  componentDidMount() {
    getTeams().then((result) => {
      this.setState({ teamData: result.data });
    });
    getTrades().then((result) => {
      this.setState({ tradeData: result.data });
    });
    this.getAssignment();
  }
  getAssignment() {
    getAssignments().then((result) => {
      this.setState({ AssignmentData: result.data });
    });
  }

  toolbarClick(args: any) {
    if (args.item.id === 'add') {
      this.setState({ hideDialog: true, firstName: '', lastName: '' });
    }
    if (args.item.id === 'edit') {
      if (this.grid.getSelectedRecords().length !== 0) {
        const id = this.grid.getSelectedRecords()[0].assignment_id;
        this.setState({ pickedAssignmentId: id });
        const name = this.grid.getSelectedRecords()[0].first_name;
        const lastname = this.grid.getSelectedRecords()[0].last_name;
        const team = this.grid.getSelectedRecords()[0].team_id;
        const trade = this.grid.getSelectedRecords()[0].trade_id;
        this.setState({
          firstName: name,
          lastName: lastname,
          teamId: team,
          tradeId: trade,
        });
        this.dialogOpenEdit();
      } else {
        Message.error('no records selected for edited operation');
      }
    }
    if (args.item.id === 'delete') {
      if (this.grid.getSelectedRecords().length !== 0) {
        const id = this.grid.getSelectedRecords()[0].assignment_id;
        this.setState({ pickedAssignmentId: id });
        this.dialogOpenDelete();
      } else {
        Message.error('no records selected for edited operation');
      }
    }
    if (args.item.id === 'refresh') {
      const getAssignment = async () => {
        this.grid.showSpinner();
        await getAssignments().then((result) => {
          this.setState({ AssignmentData: result.data });
        });
        this.grid.hideSpinner();
      };
      getAssignment();
    }
  }
  saveAssignmentWithTeamsAndTrades = async (assignment: any, obj: TeamInfo) => {
    var teamInfos: [] = (await getTeams()).data;
    var tradeInfos: [] = (await getTrades()).data;
    teamInfos.map(async (eachinfo: any) => {
      if (eachinfo.team_id == obj.team_id) {
        assignment.team_code = eachinfo.team_code;
        assignment.teams = [
          {
            assignment_id: assignment.assignment_id,
            team_code: eachinfo.team_code,
            team_id: assignment.team_id,
            app: 'UWORK',
            user_id: all_information.user_id,
            organization_id: all_information.company_id,
            creation_date: new Date(),
            created_by: all_information.user_id,
          },
        ];
      }
    });
    tradeInfos.map((eachtrade: { trade_id: number; trade_code: string }) => {
      if (eachtrade.trade_id == obj.trade_id) {
        assignment.trades = [
          {
            assignment_id: assignment.assignment_id,
            trade_code: eachtrade.trade_code,
            trade_id: obj.trade_id,
            app: 'UWORK',
            user_id: all_information.user_id,
            organization_id: all_information.company_id?.toString(),
            creation_date: new Date(),
            created_by: all_information.user_id,
          },
        ];
      }
    });

    setterTeamAndTradeToAssignment(assignment)
      .then((_response) => {
        loadingShow(false);
      })
      .catch((e) => {
        loadingShow(false);
        Message.error('Error occured');
        //(e);
      });
  };

  addAssignment = async () => {
    var firstName = this.state.firstName;
    var lastName = this.state.lastName;
    var full_name = firstName.trim() + ' ' + lastName.trim();
    const fullNameControl = full_name.replace(' ', '');
    // const nameIfExists = this.state.AssignmentData.find((x: any) => {
    //   return (
    //     x?.full_name?.toLowerCase().replace(' ', '') ===
    //     fullNameControl.toLowerCase()
    //   );
    // });
    // if (nameIfExists !== null && nameIfExists !== undefined) {
    //   Message.error('The table of the same name already exists');
    //   return false;
    // }
    let obj = {
      description: '',
      first_name: firstName,
      last_name: lastName,
      full_name: full_name,
      alias_name: full_name,
      team_id: this.state.dropdownTeamSelection,
      trade_id: this.state.dropdownTradeSelection,
      shift: '',
      image_url: '',
      is_mastered: false,
      app: 'UWORK',
      created_by: all_information.user_id,
      organization_id: all_information.company_id?.toString(),
      creation_date: new Date(),
    };
    const result = await addAssignment(obj);
    Message.success('Added successfully...');
    this.dialogClose();
    await this.saveAssignmentWithTeamsAndTrades(result.data, {
      team_id: this.state.dropdownTeamSelection,
      trade_id: this.state.dropdownTradeSelection,
    });
    this.getAssignment();
    this.dialogClose();
    console.log('result.data', result.data);
    this.props.defaultTeams.map((eachDefaulTeamId) => {
      if (result.data.team_id === eachDefaulTeamId) {
        var tempListForAssignment = [...this.props.defaultAssignments];
        tempListForAssignment.push(result.data.assignment_id);
        this.props.setAssignments(tempListForAssignment);
        var tempListForTrade = [...this.props.defaultTrades];
        tempListForTrade.push(result.data.trade_id);
        this.props.setTrades(tempListForTrade);
      }
    });
  };

  editAssignment() {
    var assignmentId = this.state.pickedAssignmentId;
    var firstName = this.state.firstName;
    var lastName = this.state.lastName;
    var full_name = firstName + ' ' + lastName;
    let obj = {
      description: '',
      first_name: firstName,
      last_name: lastName,
      full_name: full_name,
      alias_name: full_name,
      shift: '',
      image_url: '',
      assignment_id: assignmentId,
      team_id: this.state.teamId,
      trade_id: this.state.tradeId,
      is_mastered: false,
      app: 'UWORK',
      created_by: all_information.user_id,
      organization_id: all_information.company_id?.toString(),
      creation_date: new Date(),
    };

    if (firstName === '') {
      toast.error('First Name cannot be empty');
      loadingShow(false);
      return false;
    }
    if (lastName === '') {
      toast.error('Last Name cannot be empty');
      loadingShow(false);
      return false;
    }
    editAssignment(obj)
      .then((result) => {
        console.log('result', result);
        // this.props.defaultTeams.map((eachDefaulTeamId) => {
        //   if (result.data.team_id === eachDefaulTeamId) {
        //     var tempListForAssignment = [...this.props.defaultAssignments];
        //     tempListForAssignment.push(result.data.assignment_id);
        //     this.props.setAssignments(tempListForAssignment);
        //     var tempListForTrade = [...this.props.defaultTrades];
        //     tempListForTrade.push(result.data.trade_id);
        //     this.props.setTrades(tempListForTrade);
        //   }
        // });
        this.saveAssignmentWithTeamsAndTrades(result.data, {
          team_id: this.state.teamId,
          trade_id: this.state.tradeId,
        });
        loadingShow(false);
        Message.success('Added successfully...');
        this.dialogClose();
        this.getAssignment();
      })
      .catch((err) => {
        loadingShow(false);
        Message.error('Add failed!!!');
      });
    this.dialogCloseEdit();
  }

  deleteAssignment() {
    var assID = this.state.pickedAssignmentId;
    if (assID === '') {
      toast.error('Any person  was not selected ');
      loadingShow(false);
      return false;
    }
    let obj = {
      assignment_id: assID,
    };
    deleteAssignment(obj)
      .then((result) => {
        loadingShow(false);
        Message.success('Deleted  successfully...');
        this.dialogClose();
        this.getAssignment();
      })
      .catch((err) => {
        loadingShow(false);
        Message.error('Operation failed!!!');
      });
    this.dialogCloseDelete();
  }

  componentWillUnmount() {}
  successUploadImage(e: any) {}
  getAssignImage(value: any) {
    var name = defaultImage;
    var image =
      GetBackendUrlForGlobalFunctions() + 'static/media/people/' + name;
    return name;
  }
  cellRender = (args: any) => {
    if ((args.column as Column).field === 'IMG_URL') {
      const val = getValue((args.column as Column).field, args.data);
      ReactDOM.render(
        <div className='render-assign-tree'>
          <img
            className='eimage'
            src={this.getAssignImage(args.data.IMG_URL)}
          ></img>
        </div>,
        args.cell as Element
      );
    }
  };
  render() {
    return (
      <div>
        <style>
          {`
                      .render-assign-tree{
            pointer-events: none!important;
        `}
        </style>
        <GridComponent
          dataSource={this.state.AssignmentData}
          editSettings={this.editOptions}
          toolbar={this.toolbarOptions}
          ref={(g) => (this.grid = g)}
          height='calc(-270px + 100vh)'
          filterSettings={this.FilterOptions}
          allowFiltering={true}
          allowPaging={true}
          pageSettings={this.pageOptions}
          showColumnMenu={true}
          allowResizing={true}
          allowGrouping={true}
          toolbarClick={this.toolbarClick.bind(this)}
          gridLines={'Both'}
          queryCellInfo={this.cellRender}
        >
          <ColumnsDirective>
            <ColumnDirective
              field='img_url'
              headerText='#'
              textAlign='Left'
              width={50}
            />
            <ColumnDirective
              field='alias_name'
              headerText='First Name / Last Name'
              textAlign='Left'
            />
          </ColumnsDirective>
          <Inject
            services={[Edit, Toolbar, Filter, Page, ColumnMenu, Resize, Group]}
          />
        </GridComponent>
        {this.state.hideDialogEdit ? (
          <DialogComponent
            isModal={true}
            id='defaultDialogAddAssign'
            showCloseIcon={true}
            animationSettings={this.animationSettings}
            visible={this.state.hideDialogEdit}
            width={'400px'}
            height={'auto'}
            header='Tradesperson'
            buttons={this.buttonsEdit}
            open={this.dialogOpenEdit.bind(this)}
            close={this.dialogCloseEdit.bind(this)}
          >
            <div className='row mb-3'>
              <div className='col-md-3'>First Name:</div>
              <div className='col-md-9'>
                <TextBoxComponent
                  onChange={(e: any) =>
                    this.setState({
                      firstName: e.value,
                    })
                  }
                  value={this.state.firstName}
                  placeholder='Enter First Name'
                />
              </div>
            </div>
            <div className='row mb-3'>
              <div className='col-md-3'>Last Name:</div>
              <div className='col-md-9'>
                <TextBoxComponent
                  onChange={(e: any) =>
                    this.setState({
                      lastName: e.value,
                    })
                  }
                  value={this.state.lastName}
                  placeholder='Enter Last Name'
                />
              </div>
            </div>
            <div className='row mb-3'>
              <div className='col-md-3'>Team:</div>
              <div className='col-md-9'>
                <DropDownListComponent
                  dataSource={this.state.teamData}
                  fields={{ value: 'team_id', text: 'team_code' }}
                  placeholder='Select a Team'
                  value={this.state.teamId}
                  onChange={(e: any) => {
                    console.log('e', e);
                    return this.setState({
                      dropdownTeamSelectionForEdit: e.value,
                      teamId: e.value,
                    });
                  }}
                />
              </div>
            </div>
            <div className='row mb-3'>
              <div className='col-md-3'>Trade:</div>
              <div className='col-md-9'>
                <DropDownListComponent
                  dataSource={this.state.tradeData}
                  fields={{ text: 'trade_code', value: 'trade_id' }}
                  placeholder='Select a Trade'
                  value={this.state.tradeId}
                  onChange={(e: any) => {
                    console.log('e', e);
                    return this.setState({
                      dropdownTradeSelectionForEdit: e.value,
                      tradeId: e.value,
                    });
                  }}
                />
              </div>
            </div>

            <div className='row mb-3'>
              <div className='col-md-3'>Image</div>
              <div className='col-md-9'>
                <UploaderComponent />
              </div>
            </div>
          </DialogComponent>
        ) : null}

        {this.state.hideDialogDelete ? (
          <DialogComponent
            isModal={true}
            id='defaultDialogDelete'
            showCloseIcon={true}
            animationSettings={this.animationSettings}
            visible={this.state.hideDialogDelete}
            header='Confirmation'
            width={200}
            height={'auto'}
            buttons={this.buttonsDelete}
            open={this.dialogOpenDelete.bind(this)}
            close={this.dialogCloseDelete.bind(this)}
          >
            <div className='container'>
              <div className='row'>
                <span>Are you sure to delete this item?</span>
              </div>
            </div>
          </DialogComponent>
        ) : null}
        <div className='control-pane-dialogAdd'>
          <div
            id='targetElementAddAssign'
            className='col-lg-12 defaultDialogAddAssign dialog-target'
          >
            {this.state.hideDialog ? (
              <DialogComponent
                isModal={true}
                id='defaultDialogAddAssign'
                showCloseIcon={true}
                animationSettings={this.animationSettings}
                visible={this.state.hideDialog}
                width={'400px'}
                height={'auto'}
                header='Tradesperson'
                buttons={this.buttons}
                open={this.dialogOpen.bind(this)}
                close={this.dialogClose.bind(this)}
              >
                <div className='row mb-3'>
                  <div className='col-md-3'>First Name:</div>
                  <div className='col-md-9'>
                    <TextBoxComponent
                      value={this.state.firstName}
                      placeholder='Enter First Name'
                      onChange={(e: any) =>
                        this.setState({
                          firstName: e.value,
                        })
                      }
                    />
                  </div>
                </div>
                <div className='row mb-3'>
                  <div className='col-md-3'>Last Name:</div>
                  <div className='col-md-9'>
                    <TextBoxComponent
                      onChange={(e: any) =>
                        this.setState({
                          lastName: e.value,
                        })
                      }
                      value={this.state.lastName}
                      placeholder='Enter Last Name'
                    />
                  </div>
                </div>
                <div className='row mb-3'>
                  <div className='col-md-3'>Trade:</div>
                  <div className='col-md-9'>
                    <DropDownListComponent
                      dataSource={this.state.tradeData}
                      fields={{ text: 'trade_code', value: 'trade_id' }}
                      placeholder='Select a Trade'
                      onChange={(e: any) =>
                        this.setState({
                          dropdownTradeSelection: e.value,
                        })
                      }
                    />
                  </div>
                </div>

                <div className='row mb-3'>
                  <div className='col-md-3'>Team:</div>
                  <div className='col-md-9'>
                    <DropDownListComponent
                      dataSource={this.state.teamData}
                      fields={{ value: 'team_id', text: 'team_code' }}
                      placeholder='Select a Team'
                      onChange={(e: any) =>
                        this.setState({
                          dropdownTeamSelection: e.value,
                        })
                      }
                    />
                  </div>
                </div>
                <div className='row mb-3'>
                  <div className='col-md-3'>Image</div>
                  <div className='col-md-9'>
                    <UploaderComponent
                      ref={(e: UploaderComponent) => {
                        this.uploaderObj = e;
                      }}
                      multiple={false}
                      allowedExtensions={'.jpg,.png'}
                      success={this.successUploadImage.bind(this)}
                      asyncSettings={this.asyncSettings}
                    />
                  </div>
                </div>
              </DialogComponent>
            ) : null}
          </div>
        </div>
      </div>
    );
  }
}
const mapStateToProps = (state: RootState) => ({
  largeMode: state.search.largeMode,
  storeTeam: state.search.storeTeam,
  storeTrades: state.search.storeTrades,
  storeAssign: state.search.storeAssign,
  defaultTrades: state.search.defaultTrades,
  defaultTeams: state.search.defaultTeams,
  defaultAssignments: state.search.defaultAssignments,
  refreshAssignmentComponent: state.search.refreshAssignmentComponent,
});

const mapDispatchToProps = (dispatch: any) => ({
  setTrades: (data: any) => dispatch(setTrades(data)),

  setRefreshAssignmentComponent: (data: boolean) =>
    dispatch(setRefreshAssignmentComponent(data)),
  setStoreAssign: (data: any) => dispatch(setStoreAssign(data)),
  setAssignments: (data: any) => dispatch(setAssignments(data)),
  setRefreshTeamComponent: (data: boolean) =>
    dispatch(setRefreshTeamComponent(data)),
  setRefreshTradeComponent: (data: boolean) =>
    dispatch(setRefreshTradeComponent(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Teams);
